/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=13597bd4"
import script from "./PreLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreLoader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=13597bd4&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports